import { Entity, Key } from "@briebug/ngrx-auto-entity";
import { Media } from "app/shared/service/media.service";

@Entity({ modelName: "Documentation", uriName: "documentation" })
export class Documentation {
    @Key id: number;
    name: String;
    divId: String;
    fileHelp: String;
    enable: boolean;
    fichier: Media;
    constructor() {}
}
